import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import api from '@services/api';

const useGetCustomerTags = () => {
  const [customerTags, setCustomerTags] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  const getTags = useCallback(async (portfolioId?:string) => {
    setLoading(true);
    try {
      const response = await api.get('/customer/tags', {
        params: {
          portfolioId,
        },
      });
      
      setCustomerTags(response.data);
    } catch {
      toast.error('Erro ao carregar as tags. Tente novamente mais tarde.');
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    customerTags,
    getTags,
    loading,
  };
};

export default useGetCustomerTags;
